import { useDispatch } from 'react-redux';
import { actions as modalActions } from '../../../reducers/modal.reducer';
import { assetIsImage } from '../../../helpers/assets';
import Card from '../../common/card/Card.react';
import CardHeader from '../../common/card/CardHeader.react';
import CardBody from '../../common/card/CardBody.react';
import ReuploadImage from '../../common/assets/ReuploadImage.modal';
import Button from '../../common/Button.react';
var AssetReupload = function AssetReupload(props) {
  var dispatch = useDispatch();
  var type = props.type;
  if (!assetIsImage[type]) return null;
  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardHeader, {
    title: "Re-Upload Image"
  }), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 22,
      marginBottom: 30
    }
  }, "- Replacing an image will delete the old version.", /*#__PURE__*/React.createElement("br", null), "- If a cropped version of the image is used in a Section or Article, you need to re-crop after uploading, for a change to take effect."), /*#__PURE__*/React.createElement("div", {
    className: "a__btns"
  }, /*#__PURE__*/React.createElement(Button, {
    label: "Replace",
    permission: "edit-assets",
    onClick: function onClick() {
      dispatch({
        type: modalActions.add,
        payload: {
          component: /*#__PURE__*/React.createElement(ReuploadImage, props)
        }
      });
    }
  }))));
};
export default AssetReupload;